"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var base_validator_1 = require("./base-validator");

var Validator =
/** @class */
function () {
  function Validator() {
    this.menuModifierGroupName = new base_validator_1.BaseEntityFieldValidator(0, 50, base_validator_1.BaseEntityFieldValidator.genericTextInputRegexPattern);
    this.menuModifierGroupNameEN = new base_validator_1.BaseEntityFieldValidator(0, 50, base_validator_1.BaseEntityFieldValidator.genericTextInputENRegexPattern);
  }

  return Validator;
}();

exports.MenuModifierGroupValidator = new Validator();